export const fuseProvisioningEventsConstants = {
  FUSE_PROVISIONING_EVENTS_LOADING: "FUSE_PROVISIONING_EVENTS_LOADING",
  FUSE_PROVISIONING_EVENTS_SUCCESS: "FUSE_PROVISIONING_EVENTS_SUCCESS",
  FUSE_PROVISIONING_EVENTS_FAILURE: "FUSE_PROVISIONING_EVENTS_FAILURE",
};
